// @todo: Migrate to 'DropdownMenu' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';

type RunCopyIdentifiersSubmenuProps = {
  onCopyRunName: () => void;
  onCopyRunPath: () => void;
};

export const RunCopyIdentifiersSubmenu = ({
  onCopyRunName,
  onCopyRunPath,
}: RunCopyIdentifiersSubmenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DropdownMenu.Sub open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.SubTrigger>
        <Icon name="copy" />
        Copy...
        <Icon name="chevron-next" className="ml-auto text-moon-450" />
      </DropdownMenu.SubTrigger>
      <DropdownMenu.Portal>
        <DropdownMenu.SubContent className="min-w-[130px]">
          <DropdownMenu.Item onSelect={onCopyRunName}>
            Run name
          </DropdownMenu.Item>
          <DropdownMenu.Item onSelect={onCopyRunPath}>
            Run path
          </DropdownMenu.Item>
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
};
